/**
 * @generated SignedSource<<d7cead7af74411c4dbb21233d1123941>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BidPendingContent_nftItem$data = {
  readonly metadata: {
    readonly media?: {
      readonly posterFrameUrl: string | null;
      readonly webUrl: string | null;
    } | null;
    readonly name?: string | null;
  } | null;
  readonly " $fragmentType": "BidPendingContent_nftItem";
};
export type BidPendingContent_nftItem$key = {
  readonly " $data"?: BidPendingContent_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"BidPendingContent_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BidPendingContent_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftDigitalArtMetadataMedia",
              "kind": "LinkedField",
              "name": "media",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "webUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "posterFrameUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "0c43d5effc1ba9b7e16ae5e8b149ea7c";

export default node;
